(function() {
'use strict';

angular
    .module('parking')
    .controller('ParkingSearchUnit', Parking);

function Parking(searchUnitService,
                 dateUtil,
                 $window,
                 $scope,
                 resourceService,
                 broker,
                 basketService,
                 $timeout) {
    const cm = this;
    const mode = searchUnitService.parking;

    $timeout(() => {
        const selectedDepartureAirport = searchUnitService.getSelectedDepartureAirport();
        if (selectedDepartureAirport && selectedDepartureAirport.Code && selectedDepartureAirport.Code.indexOf(',') > -1) {
            searchUnitService.clearDepartureAirports();
        }
        cm.summary = searchUnitService.getSummary(mode);
    });

    const minimumDate = dateUtil.todayPlus(1, 0, true);
    const minimumDatePlusOne = dateUtil.addDays(minimumDate, 1, true) || dateUtil.todayPlus(1, 0, true);
    let initStartPlusOne;

    cm.setStartDate = setStartDate;
    cm.setEndDate = setEndDate;
    cm.search = search;
    cm.startDate = searchUnitService.startDate(mode);
    cm.endDate = searchUnitService.endDate(mode);

    if (cm.startDate) {
        initStartPlusOne = dateUtil.addDays(cm.startDate, 1, true);
    }
    cm.minDates = {
        minimumDate,
        startPlusOne: initStartPlusOne || minimumDatePlusOne
    };

    function setStartDate(date, back) {
        if (date) {
            cm.minDates.startPlusOne = dateUtil.addDays(date, 1, true);
        }
        searchUnitService.startDate(mode, date);
        cm.summary = searchUnitService.getSummary(mode);
        if (back) {
            setTimeout(function() {
                $window.history.back();
            }, 0);
        }
    }

    function setEndDate(date, back) {
        searchUnitService.endDate(mode, date);
        cm.summary = searchUnitService.getSummary(mode);
        cm.showEndCalendar = false;
        if (back) {
            setTimeout(function() {
                $window.history.back();
            }, 0);
        }
    }

    const flow = basketService.parkingBooking;

    /*Can be moved to a directive*/
    function search() {
        $scope.$emit('block', {
            title: resourceService.get('SEARCHINGPARKING'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'default-parkingSearchUnit'
        });
        basketService.startWorkflow(flow).then(null, function(errors) {
            broker.publish('unblock');
            $scope.$emit('unblock');
            $scope.$emit('flash:error', errors);
        });
    }
}
})();
